module.exports = __webpack_public_path__ + "assets/2e0cc2e6209a6b3ba0de2d004150ac57.json";